(function () {
  function money(c) { return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 }); }
  function handle(s) { return String(s).toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function norm(s) { return String(s).toLowerCase().replace(/\s*-\s*rough sawn$/, '').trim(); }
  function parse(el) { try { return JSON.parse(el.textContent); } catch (e) { return []; } }
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('cart-count').forEach(function (el) { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
    }).catch(function () {});
  }

  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var fi = parseInt(root.dataset.fi, 10);
    var variants = parse(root.querySelector('[data-variants]'));
    var optNames = parse(root.querySelector('[data-options]')).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var form = root.querySelector('[data-form]');
    var input = root.querySelector('[data-variant-id]');
    var cur = variants.find(function (v) { return String(v.id) === String(input.value); }) || variants[0];
    if (!cur) return;
    var sel = cur.options.slice();
    var priceEl = root.querySelector('[data-price]'), atc = root.querySelector('[data-atc]');
    var barPrice = root.querySelector('[data-bar-price]'), barAtc = root.querySelector('[data-bar-atc]');
    var track = root.querySelector('[data-track]'), countEl = root.querySelector('[data-count]');
    var slides = [].slice.call(root.querySelectorAll('.dqp__slide'));
    var gal = root.querySelector('.dqp__gallery'), pan = root.querySelector('.dqp__panel');

    function visible() { return slides.filter(function (s) { return !s.hidden; }); }
    function updateCount() {
      var v = visible(); if (!countEl || !v.length) return;
      var i = Math.round(track.scrollLeft / (track.clientWidth || 1)) + 1;
      countEl.textContent = Math.min(i, v.length) + ' / ' + v.length;
    }
    function filterGallery() {
      var picked = {};
      optNames.forEach(function (n, i) { picked[handle(n)] = handle(sel[i]); });
      var any = false;
      slides.forEach(function (s) {
        var t = s.dataset.tag;
        if (t === 'all') return;
        var k = t.slice(0, t.indexOf('_')), val = t.slice(t.indexOf('_') + 1);
        var on = picked.hasOwnProperty(k) ? picked[k] === val : true;
        s.hidden = !on; if (on) any = true;
      });
      slides.forEach(function (s) { if (s.dataset.tag === 'all') s.hidden = any; });
      if (!any) slides.forEach(function (s) { s.hidden = false; });
      var first = visible()[0]; slides.forEach(function (s) { s.classList.toggle('is-hero', s === first); });
      root.classList.toggle('dqp--few', visible().length < 5);
      track.scrollLeft = 0; updateCount();
    }

    var cards = [].slice.call(root.querySelectorAll('[data-pc]')).map(function (c) {
      var meta = c.querySelector('[data-pc-meta]');
      return { el: c, vars: parse(c.querySelector('[data-pc-variants]')), id: null, metaDefault: meta ? meta.textContent : '' };
    });
    function syncCards() {
      var want = fi >= 0 ? norm(sel[fi]) : null;
      var first = want ? want.split(/[\s\/-]/)[0] : null;
      cards.forEach(function (c) {
        if (!c.vars.length) return;
        var m = null, matched = '';
        if (want) {
          c.vars.some(function (v) { return v.options.some(function (o) { if (norm(o) === want) { m = v; matched = o; return true; } return false; }); });
          if (!m) c.vars.some(function (v) { return v.options.some(function (o) { if (norm(o).split(/[\s\/-]/)[0] === first) { m = v; matched = o; return true; } return false; }); });
        }
        if (!m) m = c.vars.find(function (v) { return v.available; }) || c.vars[0];
        c.id = m.id;
        var p = c.el.querySelector('[data-pc-price]'); if (p && matched) p.textContent = money(m.price);
        var img = c.el.querySelector('.dqp__pci img');
        if (img && matched && m.featured_image && m.featured_image.src) { img.removeAttribute('srcset'); img.src = m.featured_image.src + (m.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=400'; }
        var meta = c.el.querySelector('[data-pc-meta]');
        if (meta) meta.textContent = matched ? 'In ' + String(matched).replace(/\s*-\s*Rough Sawn$/, '') : c.metaDefault;
        c.el.querySelectorAll('a[href]').forEach(function (a) { var u = a.getAttribute('href').split('?')[0]; if (u.indexOf('/cart') === 0) return; a.setAttribute('href', matched ? u + '?variant=' + m.id : u); });
        var add = c.el.querySelector('[data-pc-add]');
        if (add) { add.disabled = !m.available; add.textContent = m.available ? 'Add to Cart' : 'Sold out'; }
      });
    }
    cards.forEach(function (c) {
      var qv = c.el.querySelector('[data-qv]');
      c.el.querySelectorAll('[data-q]').forEach(function (b) {
        b.addEventListener('click', function () { qv.textContent = Math.max(1, Math.min(10, (parseInt(qv.textContent, 10) || 1) + parseInt(b.dataset.q, 10))); });
      });
      var add = c.el.querySelector('[data-pc-add]');
      if (!add) return;
      add.addEventListener('click', function () {
        if (!c.id) return;
        add.disabled = true; add.textContent = 'Adding...';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: c.id, quantity: parseInt(qv.textContent, 10) || 1 }] }) })
          .then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () {
            var a = document.createElement('a'); a.className = 'dqp__pca'; a.href = '/cart'; a.textContent = 'Added. View cart';
            add.replaceWith(a); refreshCartCount();
          })
          .catch(function () { add.disabled = false; add.textContent = 'Try again'; });
      });
    });

    function showVariantPhoto(v) {
      var fm = v && v.featured_media; if (!fm) return;
      var s = slides.find(function (x) { return String(x.dataset.mid) === String(fm.id); });
      if (!s || s.hidden) return;
      if (track.firstElementChild !== s) track.insertBefore(s, track.firstElementChild);
      slides = [].slice.call(track.querySelectorAll('.dqp__slide'));
      var first = visible()[0]; slides.forEach(function (x) { x.classList.toggle('is-hero', x === first); });
      track.scrollLeft = 0; updateCount();
    }
    function apply() {
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
      if (!v) { atc.disabled = barAtc.disabled = true; atc.textContent = barAtc.textContent = 'Unavailable'; return; }
      input.value = v.id;
      showVariantPhoto(v);
      priceEl.textContent = barPrice.textContent = money(v.price);
      atc.disabled = barAtc.disabled = !v.available;
      atc.textContent = barAtc.textContent = v.available ? 'Add to Cart' : 'Sold out';
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u); } catch (e) {}
    }

    var steps = [].slice.call(root.querySelectorAll('[data-step]'));
    root.querySelectorAll('[data-toggle]').forEach(function (b) {
      b.addEventListener('click', function () { b.parentNode.classList.toggle('is-open'); restick(); });
    });
    root.querySelectorAll('[data-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = parseInt(b.dataset.opt, 10);
        root.querySelectorAll('[data-opt="' + k + '"]').forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on'); sel[k] = b.dataset.value;
        var val = root.querySelector('[data-val="' + k + '"]'); if (val) val.textContent = b.dataset.label;
        var sw = root.querySelector('[data-swname="' + k + '"]'); if (sw) sw.textContent = b.dataset.label;
        filterGallery(); if (k === fi) syncCards();
        var me = b.closest('[data-step]'), idx = steps.indexOf(me), next = steps[idx + 1];
        if (next && !next.dataset.seen) { next.dataset.seen = '1'; next.classList.add('is-open'); }
        apply(); restick();
      });
    });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(updateCount); }, { passive: true });

    root.querySelectorAll('.dqp__mq').forEach(function (w) {
      var i = w.querySelector('[data-mqv]');
      w.querySelectorAll('[data-mq]').forEach(function (b) {
        b.addEventListener('click', function () { i.value = Math.max(1, Math.min(20, (parseInt(i.value, 10) || 1) + parseInt(b.dataset.mq, 10))); });
      });
    });

    var bar = root.querySelector('[data-bar]');
    if (bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', past); bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      }).observe(atc);
    }
    barAtc.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(atc); else atc.click(); });

    function stick() {
      [gal, pan].forEach(function (el) { el.style.position = ''; el.style.top = ''; });
      if (window.innerWidth < 990) return;
      var s = gal.offsetHeight < pan.offsetHeight ? gal : pan;
      s.style.position = 'sticky';
      s.style.top = Math.min(110, window.innerHeight - s.offsetHeight - 96) + 'px';
    }
    var t; function restick() { clearTimeout(t); t = setTimeout(stick, 60); }
    if ('ResizeObserver' in window) { var ro = new ResizeObserver(restick); ro.observe(gal); ro.observe(pan); }
    window.addEventListener('resize', restick);
    root.querySelectorAll('details').forEach(function (d) { d.addEventListener('toggle', restick); });

    filterGallery(); syncCards(); apply(); stick();
  }

  function boot() { document.querySelectorAll('.dqp').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();